import AppSidebar from '../AppSidebar';
import { Navbar } from '../Components/Catalyst/navbar';
import { SidebarLayout } from '../Components/Catalyst/sidebar-layout';
import { Heading, Subheading } from '../Components/Catalyst/heading';
import { Divider } from '../Components/Catalyst/divider';
import ViolationList from './ViolationList';
import LoadingSpinner from '../LoadingSpinner';
import { useMember } from '../Hooks/MemberContext';

interface ViolationPageProps {
  currentPage: string; // Keep this prop as it's needed for sidebar navigation
}

const ViolationPage: React.FC<ViolationPageProps> = ({ currentPage }) => {
  // The list is scoped by the caller's token on the server, so there is
  // no member id to pass down. This only waits so the sidebar has a name
  // to render.
  const { loading } = useMember();
  if (loading) {
    return <LoadingSpinner></LoadingSpinner>;
  }

  return (
    <SidebarLayout
      sidebar={<AppSidebar currentPage={currentPage} />}
      navbar={<Navbar>{/* Your navbar content */}</Navbar>}
    >
      {/* Your page content */}
      <Heading>All Violations</Heading>
      <Subheading>More to come soon!</Subheading>

      <Divider className="mt-4 mb-6"></Divider>

      <ViolationList></ViolationList>
    </SidebarLayout>
  );
};

export default ViolationPage;
